import "./kakotora-date-local-fix-production";
import "./production-token-upload-final-fix";
import "./chartjs-register";
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import "./oee-report-harian-runtime-fix";
import "./oee-report-harian-table-fix.css";
import "./ticketing-donut-public-shape-fix-v14";

import "./oee-hourly-production-reminder.css";
import "./oee-hourly-production-reminder";
import "./oee-input-display-normalizer-v1";

import "./public-role-safe-home-runtime-v8";
import "./public-ticketing-detail-runtime-v8";
import "./wo-status-layout-runtime-v1";
import "./wo-dashboard-report-ui-fix-v1";
import "./oee-master-search-reminder-close-v1";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
